module.exports = __webpack_public_path__ + "static/media/tofu.b5888b74.png";